import { DxpStorageService } from '../../storage.service';
import { Injectable } from '@angular/core';
import { CustomMessageListener } from '@openmfp/portal-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class ProjectCreatedListener implements CustomMessageListener {
  constructor(private storageService: DxpStorageService) {}
  messageId(): string {
    return 'org.project-created';
  }
  onCustomMessageReceived(): void {
    this.refreshToken();
  }

  private refreshToken() {
    localStorage.removeItem('luigi.auth');
    this.storageService.clearLocalStorage();
  }
}
